import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Latest Arrivals"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "More than 100 new products")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-150px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-125px" }),
    /*#__PURE__*/_createVNode("th", { class: "p-0 min-w-40px" })
  ])
], -1)
const _hoisted_10 = { class: "symbol symbol-50px me-2" }
const _hoisted_11 = { class: "symbol-label" }
const _hoisted_12 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_13 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-muted fw-bold" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = {
  href: "#",
  class: "\n                      btn btn-sm btn-icon btn-bg-light btn-active-color-primary\n                    "
}
const _hoisted_19 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("button", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("table", _hoisted_8, [
          _hoisted_9,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("span", _hoisted_11, [
                      _createVNode("img", {
                        src: item.image,
                        class: "h-50 align-self-center",
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ]),
                _createVNode("td", null, [
                  _createVNode("a", _hoisted_12, _toDisplayString(item.info.title), 1),
                  _createVNode("span", _hoisted_13, _toDisplayString(item.info.description), 1)
                ]),
                _createVNode("td", _hoisted_14, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.badges, (item1, index1) => {
                    return (_openBlock(), _createBlock("span", {
                      key: index1,
                      class: [`badge-light-${item1.color}`, "badge fw-bold me-1"]
                    }, _toDisplayString(item1.label), 3))
                  }), 128))
                ]),
                _createVNode("td", _hoisted_15, [
                  _createVNode("span", _hoisted_16, _toDisplayString(item.remarks), 1)
                ]),
                _createVNode("td", _hoisted_17, [
                  _createVNode("a", _hoisted_18, [
                    _createVNode("span", _hoisted_19, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}